import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsAccordion = function (props) {
    var accordionConfig = props.accordionConfig, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-accordion", { ref: ref, "accordion-config": accordionConfig ? (typeof accordionConfig === 'string' ? accordionConfig : JSON.stringify(accordionConfig)) : undefined }, children));
};
export default VeltNotificationsPanelSettingsAccordion;
